<template>
	<div class="project">
		<!-- 操作按钮（详情页编辑态） -->
		<div class="clear-both mb-2 mr-4" v-show="type == 2">
			<el-button type="primary" class="fr ml-1" :loading="loadingAddBtn" @click="postCusInfo">
				{{ loadingAddBtn ? '保存中...' : '保存' }}
			</el-button>
			<el-button class="fr mr-1" :disabled="isEdit" v-show="isDisabled" @click="isDisabled = false">编辑</el-button>
			<el-button class="fr mr-1" v-show="!isDisabled" @click="cancelEdit">取消</el-button>
		</div>

		<el-form ref="projectForm" :model="project" :rules="rules" label-position="left" label-width="120px"
			class="employer-ruleForm">
			<!-- 企业名称 -->
			<el-row v-show="type != 2">
				<el-col :span="24">
					<el-form-item label="企业名称" required>
						<seach v-show="project.company == '1'" ref="customerSearch" @select="handleSelect"></seach>
						<el-input v-show="project.company == '2'" v-model="project.customerName"
							placeholder="请输入项目发起方名称" class="inp_text"></el-input>
					</el-form-item>
				</el-col>
			</el-row>

			<!-- 成对展示的字段：配置化渲染，避免模板重复 -->
			<el-row v-for="(pair, rowIndex) in projectFieldRows" :key="rowIndex">
				<el-col v-for="(field, colIndex) in pair" :key="field.prop" :span="10"
					:offset="colIndex === 1 ? 3 : 0">
					<el-form-item :label="field.label" :prop="field.prop">
						<el-select v-if="field.type === 'select'" v-model="project[field.prop]"
							:placeholder="field.placeholder || '请选择'" style="width: 100%;" :disabled="isDisabled">
							<el-option v-for="opt in field.options" :key="opt.value" :label="opt.label"
								:value="opt.value"></el-option>
						</el-select>
						<el-cascader v-else-if="field.type === 'cascader'" style="width: 100%;"
							v-model="project[field.prop]" :options="field.options" :disabled="isDisabled">
						</el-cascader>
						<template v-else>
							<div class="fl mr-1">
								<el-input v-model="project[field.prop]" :disabled="isDisabled"></el-input>
							</div>
							<template v-if="field.unit">{{ field.unit }}</template>
						</template>
					</el-form-item>
				</el-col>
			</el-row>

			<!-- 项目附件 -->
			<el-row>
				<el-col :span="24">
					<el-form-item label="项目附件" prop="fileList">
						<el-upload class="upload-demo" action="#" :http-request="uploadFileList"
							:on-preview="handlePreview" :on-remove="handleRemove" :on-success="handleAvatarSuccess"
							:on-exceed="handleExceed" :before-remove="beforeRemove" :limit="4" multiple
							:file-list="project.projectFileList" :show-file-list="project.showFileList"
							accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx">
							<el-button size="small" type="primary" :disabled="isDisabled">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">
								仅支持上传 Word、PDF、Excel、PPT格式，且单个文件大小不超过 30MB
							</div>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>

			<!-- 完整性评估 -->
			<el-row v-if="type != 1">
				<el-col :span="24">
					<el-form-item label="项目信息完整性评估" label-width="160px">
						<el-button type="primary" :loading="completenesLoading" @click="initEvaluation(1)">
							查看项目完整性评估
						</el-button>
					</el-form-item>
				</el-col>
			</el-row>

			<!-- 长文本字段 -->
			<el-row v-for="field in textareaFields" :key="field.prop">
				<el-col :span="24">
					<el-form-item :label="field.label" :prop="field.prop">
						<el-input type="textarea" v-model="project[field.prop]" :disabled="isDisabled"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<!-- 联系人（新增时展示） -->
		<div v-if="type == 1">
			<el-divider><i class="el-icon-user-solid"></i>联系人</el-divider>
			<h3 class="mb-3 content-title">联系人</h3>
			<el-form ref="contactForm" :model="contact" :rules="contactRules" label-width="120px">
				<el-row v-for="(pair, rowIndex) in contactFieldRows" :key="rowIndex">
					<el-col v-for="(field, colIndex) in pair" :key="field.prop" :span="10"
						:offset="colIndex === 1 ? 3 : 0">
						<el-form-item :label="field.label" :prop="field.prop">
							<el-select v-if="field.type === 'select'" v-model="contact[field.prop]"
								:disabled="isDisabled">
								<el-option v-for="opt in field.options" :key="opt.value" :label="opt.label"
									:value="opt.value"></el-option>
							</el-select>
							<el-input v-else-if="field.type === 'textarea'" type="textarea"
								v-model="contact[field.prop]" :disabled="isDisabled"></el-input>
							<el-input v-else v-model="contact[field.prop]" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>

		<!-- 保存按钮（新增态） -->
		<div class="clear-both" v-show="type == 1">
			<el-button type="primary" class="fr" :loading="loadingAddBtn" @click="postCusInfo">
				{{ loadingAddBtn ? '保存中...' : '保存' }}
			</el-button>
		</div>

		<el-dialog class="localChain " custom-class="initiate_box_dialog white-bg" :title="dialogTitle" center
			:visible.sync="isInitiate" top="">
			<div class="pre-wrap-text " v-html="sanitizedCompletenessData"></div>
		</el-dialog>
	</div>
</template>

<script>
import seach from './seach.vue';

/** 初始项目数据工厂：data 与 resetForm 共用同一份定义，避免漏改 */
function createInitialProject() {
	return {
		name: '',
		summary: '',
		showFileList: true,
		status: '',
		investorName: '',
		district: '',
		industryType: [],
		investmentAmount: '',
		expectedAnnualOutput: '',
		expectedProfit: '',
		expectedEmployment: '',
		demand: '',
		policy: '',
		projectFileList: [],
		fileList: [],
		company: '1',
		customerName: '',
		taxation: '',
	};
}

/** 初始联系人数据工厂 */
function createInitialContact() {
	return {
		contactId: 0,
		contactName: '',
		mobile: '',
		gender: '',
		departmentName: '',
		position: '',
		weixin: '',
		qq: '',
		email: '',
		remark: '',
		customerId: '',
	};
}

/** 极简 HTML 白名单消毒：仅保留基础排版标签，防 XSS */
function sanitizeHtml(html) {
	if (!html) return '';
	return String(html)
		.replace(/<\s*(script|iframe|object|embed|link|meta)[^>]*>[\s\S]*?<\s*\/\s*\1\s*>/gi, '')
		.replace(/<\s*(script|iframe|object|embed|link|meta)[^>]*\/?>/gi, '')
		.replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
		.replace(/(href|src)\s*=\s*(["'])\s*javascript:[^"']*\2/gi, '$1=$2#$2');
}

export default {
	name: 'addProject',
	components: { seach },
	props: {
		type: { default: 1, type: Number },        // 1 新增  2 详情页编辑
		projectData: { default: () => ({}), type: Object },
		cusid: { default: 0, type: [String, Number] },
		isEdit: { default: false, type: Boolean },
	},
	data() {
		return {
			project: createInitialProject(),
			contact: createInitialContact(),
			loadingAddBtn: false,
			isDisabled: false,
			projectStatusOptions: [
				{ value: '1', label: '待处理' },
				{ value: '2', label: '处理中' },
				{ value: '3', label: '处理完成' },
			],
			industryTypeOptions: [],
			userdata: {},
			contactRules: {},
			rules: {
				name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
				status: [{ required: true, message: '请选择项目状态', trigger: 'change' }],
				industryType: [{ type: 'array', required: true, message: '请选择产业类型', trigger: 'change' }],
				investorName: [{ required: true, message: '请输入投资人名称', trigger: 'blur' }],
				investmentAmount: [{ required: true, message: '请输入投资总额', trigger: 'blur' }],
				expectedAnnualOutput: [{ required: true, message: '请输入预计年产值', trigger: 'blur' }],
				fileList: [
					{ required: true, message: '请上传项目文件', trigger: 'change' },
					{ type: 'array', min: 1, message: '请至少上传一个文件', trigger: 'change' },
				],
				summary: [{ required: true, message: '请输入项目简介', trigger: 'blur' }],
			},
			detailData: {},
			isInitiate: false,
			dialogTitle: '项目信息完整性评估',
			completenessData: '',
			completenesLoading: false,
			pageType: 1, // 1 新增  2 详情页编辑（点击保存后若原 type==1 则置 3）
		};
	},
	computed: {
		/** v-html 内容消毒后再渲染 */
		sanitizedCompletenessData() {
			return sanitizeHtml(this.completenessData);
		},
		/** 项目字段配置（成对两行布局） */
		projectFieldRows() {
			return [
				[
					{ label: '项目名称', prop: 'name' },
					{ label: '项目状态', prop: 'status', type: 'select', options: this.projectStatusOptions },
				],
				[
					{ label: '投资方名称', prop: 'investorName' },
					{ label: '产业类型', prop: 'industryType', type: 'cascader', options: this.industryTypeOptions },
				],
				[
					{ label: '投资总额', prop: 'investmentAmount', unit: '亿元' },
					{ label: '预计年产值', prop: 'expectedAnnualOutput', unit: '亿元' },
				],
				[
					{ label: '预计利润', prop: 'expectedProfit', unit: '亿元' },
					{ label: '预计就业人数', prop: 'expectedEmployment', unit: '人' },
				],
				[
					{ label: '税收', prop: 'taxation', unit: '亿元' },
				],
			];
		},
		textareaFields() {
			return [
				{ label: '项目简介', prop: 'summary' },
				{ label: '项目落地诉求', prop: 'demand' },
				{ label: '项目政策诉求', prop: 'policy' },
			];
		},
		contactFieldRows() {
			return [
				[
					{ label: '姓名', prop: 'contactName' },
					{ label: '手机号', prop: 'mobile' },
				],
				[
					{ label: '性别', prop: 'gender', type: 'select', options: [{ label: '男', value: '1' }, { label: '女', value: '2' }] },
					{ label: '部门', prop: 'departmentName' },
				],
				[
					{ label: '职位', prop: 'position' },
					{ label: '微信', prop: 'weixin' },
				],
				[
					{ label: 'QQ', prop: 'qq' },
					{ label: '邮箱', prop: 'email' },
				],
				[
					{ label: '备注', prop: 'remark', type: 'textarea' },
				],
			];
		},
	},
	watch: {
		type: {
			immediate: true,
			handler(newVal) {
				// 详情页默认只读；新增/编辑态可写
				this.isDisabled = newVal === 2;
				this.pageType = newVal;
			},
		},
		projectData: {
			immediate: true,
			handler(newVal) {
				if (newVal && Object.keys(newVal).length) {
					this.pageData();
				}
			},
		},
	},
	created() {
		this.userdata = this.getuseriformation();
	},
	mounted() {
		this.getProjectClass();
		this.getStatusType();
	},
	methods: {
		/* ---------- 项目完整性评估 ---------- */
		initEvaluation(type) {
			if (type === 1) {
				this.completeness();
			} else {
				this.isInitiate = true;
			}
		},
		async completeness() {
			this.completenesLoading = true;
			try {
				const res = await this.$axios.get(
					this.$api.crm.assessment.Completeness() + '?customerId=' + this.cusid,
					{ headers: { AuthToken: this.userdata.token } }
				);
				if (res.data.success) {
					this.completenessData = res.data.data;
					this.isInitiate = true;
				} else {
					this.$message.error(res.data.msg);
				}
			} catch (error) {
				console.error('评估请求失败:', error);
				this.$message.error('评估请求失败，请稍后重试');
			} finally {
				this.completenesLoading = false;
			}
		},

		/* ---------- 数据回填 ---------- */
		pageData() {
			const src = this.projectData || {};
			const project = this.project;
			// 兼容父组件或后端不同字段命名
			project.name = src.name || src.project || '';
			project.summary = src.summary || src.remark || '';
			project.fileName = src.file || src.fileName || '';
			project.projectFileList = src.fileList || src.projectFileList || [];
			project.fileList = src.fileList || src.projectFileList || [];
			project.status = src.status || '';
			// industryType 可能以 bigClass/smallClass 或数组形式提供
			const big = src.bigClass !== undefined
				? src.bigClass
				: (Array.isArray(src.industryType) ? src.industryType[0] : undefined);
			const small = src.smallClass !== undefined
				? src.smallClass
				: (Array.isArray(src.industryType) ? src.industryType[1] : undefined);
			project.industryType = (big || small) ? [big || '', small || ''] : [];
			project.investmentAmount = src.amount || src.investmentAmount || '';
			project.expectedAnnualOutput = src.outputValue || src.expectedAnnualOutput || '';
			project.expectedProfit = src.profit || src.expectedProfit || '';
			project.expectedEmployment = src.employment || src.expectedEmployment || '';
			project.demand = src.landing || src.demand || '';
			project.policy = src.policy || '';
			project.investorName = src.investor || src.investorName || '';
			project.customerName = src.customerName || '';
			project.taxation = src.taxation || '';

			// 规范文件列表 item.name 字段
			if (Array.isArray(project.projectFileList) && project.projectFileList.length) {
				project.projectFileList.forEach(item => {
					item.name = item.title || item.name;
				});
			}
		},

		/* ---------- 企业搜索 ---------- */
		handleSelect(company) {
			// company 可能为对象或字符串，统一取名称
			this.project.customerName = (company && typeof company === 'object') ? (company.name || company.label || '') : company;
		},

		/* ---------- 下拉数据 ---------- */
		async getProjectClass() {
			try {
				const res = await this.$axios.get(this.$api.tag.notion.list() + '?level=3', {
					headers: { AuthToken: this.userdata.token },
				});
				if (res.data.success) {
					const datalist = (res.data.list || []).filter(list => list.label.indexOf('未来') < 0);
					this.industryTypeOptions = this.setIsIntegration(datalist);
				}
			} catch (error) {
				console.error('获取产业类型失败:', error);
			}
		},
		setIsIntegration(notionArray) {
			const tempData = { label: '传统产业', value: 'DEF', parentList: ['DEF'], children: [] };
			const newTree = [];
			notionArray.forEach(item => {
				if (item.label === '第一产业' || item.label === '第二产业' || item.label === '第三产业') {
					tempData.children.push(item);
					newTree[0] = tempData;
				}
				if (item.label === '先进制造业') {
					newTree[1] = { ...item, label: '战略性新兴产业' };
				}
				if (item.label === '未来产业') {
					newTree[2] = item;
				}
			});
			return newTree;
		},
		async getStatusType() {
			try {
				const res = await this.$axios.get(this.$api.crm.parameter.projectStatus(), {
					headers: { AuthToken: this.userdata.token },
				});
				if (res.data.success) {
					this.projectStatusOptions = res.data.list || [];
				}
			} catch (error) {
				console.error('获取项目状态失败:', error);
			}
		},

		/* ---------- 附件 ---------- */
		handleRemove(file, fileList) {
			this.deleteFile(file.fileId)
				.then(ok => {
					if (ok) this.project.projectFileList = fileList;
				})
				.catch(() => { /* 删除失败，保留文件列表不变 */ });
		},
		handlePreview(file) {
			window.open(file.url, '_blank');
		},
		handleAvatarSuccess(res, file, fileList) {
			this.project.fileList = fileList;
		},
		handleExceed(files, fileList) {
			this.$message.warning(`当前限制选择 4 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		beforeRemove(file) {
			return this.$confirm(`确定移除 ${file.name}？`);
		},
		handleOpenURL(url) {
			window.open(url, '_blank');
		},
		/** 删除附件：新增态（type==1）本地删除不请求后端；详情态调接口 */
		deleteFile(id) {
			return new Promise((resolve, reject) => {
				if (this.type === 1) {
					resolve(true);
					return;
				}
				if (!id) {
					this.$message.warning('文件尚未保存到服务器，无需删除');
					resolve(true);
					return;
				}
				const formData = new FormData();
				formData.append('fileId', id);
				this.$axios.post(this.$api.crm.customer.deleteFile(), formData, {
					headers: { AuthToken: this.userdata.token },
				}).then(res => {
					if (res.data.success) {
						this.$message.success('删除成功！');
						resolve(true);
					} else {
						this.$message.error(res.data.msg);
						reject(false);
					}
				}).catch(err => {
					console.error('删除文件失败:', err);
					this.$message.error('删除失败，请稍后重试');
					reject(false);
				});
			});
		},
		/** 上传附件（真正生效的版本，含进度回调） */
		// 修改后的上传方法 - 添加进度条支持
    async uploadFileList(file) {
      if(this.pageType == 1){
		return;
	  }
      try {
        let addFileUrl = this.$api.crm.customer.addFile();
        let formData = new FormData();
        formData.append('file', file.file);
        formData.append('customerId', this.detailData.id ? this.detailData.id : this.cusid);
        
        const response = await this.$axios.post(addFileUrl, formData, {
          headers: {
            'AuthToken': this.userdata.token,
            'Content-Type': 'multipart/form-data'
          },
          // 关键：添加上传进度监听
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            //   console.log('上传进度:', percent + '%');
              
              // 手动调用进度回调 - 这是显示进度条的关键！
              file.onProgress({
                percent: percent
              });
            }
          }
        });
        
        console.log(response);
        if (response.data.success) {
			this.project.fileList = response.data.list;
          // 上传成功回调
          file.onSuccess(response.data);
		  
        //   this.$message.success('上传成功！');
        } else {
        //   file.onError(new Error(response.data.msg || '上传失败'));
          this.$message.error(response.data.msg || '上传失败');
        }
        
      } catch (error) {
        console.log('上传错误:', error);
      }
    },

		/* ---------- 提交 ---------- */
		postCusInfo() {
			this.$refs.projectForm.validate(valid => {
				if (!valid) {
					this.$message.error('请填写完整的项目信息');
					return;
				}
				if (this.isDisabled) {
					this.$message.warning('当前为只读状态，请先点击"编辑"');
					return;
				}
				// type==1 保存后置 pageType=3，后续附件上传走服务端
				if (this.type === 1) {
					this.pageType = 3;
				}
				this.loadingAddBtn = true;
				const formData = new FormData();
				formData.append('customerId', this.cusid === '' ? 0 : this.cusid);
				formData.append('project', this.project.name);
				formData.append('summary', this.project.summary);
				// 产业类型兜底，避免 append('xxx', undefined) 变成字符串 "undefined"
				const [bigClass = '', smallClass = ''] = this.project.industryType || [];
				formData.append('bigClass', bigClass);
				formData.append('smallClass', smallClass);
				formData.append('status', this.project.status);
				formData.append('amount', this.project.investmentAmount);
				formData.append('outputValue', this.project.expectedAnnualOutput);
				formData.append('profit', this.project.expectedProfit);
				formData.append('employment', this.project.expectedEmployment);
				formData.append('landing', this.project.demand);
				formData.append('policy', this.project.policy);
				formData.append('investor', this.project.investorName);
				formData.append('customerName', this.project.customerName);
				formData.append('taxation', this.project.taxation);

				// 如需父组件协同处理（只发事件，不再自行提交），打开下一行并删掉下方 axios：
				// this.$emit('postCusInfo', formData); return;
				this.$axios.post(this.$api.crm.project.Post(), formData, {
					headers: { AuthToken: this.userdata.token },
				}).then(res => {
					if (res.data.success) {
						this.$message.success('项目添加成功!');
						this.detailData = res.data.data;
						// 项目创建完成后补传附件
						const pendingFiles = this.project.fileList || [];
						pendingFiles.forEach(f => this.uploadFileList({ file: f.raw, onProgress: () => {}, onSuccess: () => {}, onError: () => {} }));
						// 有联系人信息则随后提交
						if (this.contact.contactName) {
							this.postCusContact();
						}
					} else {
						this.$message.error('添加失败：' + res.data.msg);
					}
				}).catch(err => {
					console.error('上传失败:', err);
					this.$message.error('上传失败，请稍后重试');
				}).finally(() => {
					this.loadingAddBtn = false;
				});
			});
		},
		/** 提交联系人（修复 _this 未定义 + 统一 axios；空字段剔除） */
		postCusContact() {
			const { mobile, email } = this.contact;
			if (mobile && mobile.trim() && !/^1[3-9]\d{9}$/.test(mobile)) {
				this.$message.error('手机号格式不正确');
				return;
			}
			if (email && email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
				this.$message.error('邮箱格式不正确');
				return;
			}
			const postData = { ...this.contact, customerId: this.detailData.id };
			Object.keys(postData).forEach(key => {
				if (postData[key] === '' || postData[key] === null || postData[key] === undefined) {
					delete postData[key];
				}
			});
			this.$axios.post(this.$api.crm.contact.post(), postData, {
				headers: { AuthToken: this.userdata.token },
			}).then(res => {
				if (res.data.success) {
					this.$message.success('联系人保存成功!');
				} else {
					this.$message.error(res.data.msg || '联系人保存失败');
				}
			}).catch(err => {
				console.error('联系人保存失败:', err);
				this.$message.error('联系人保存失败，请稍后重试');
			});
		},

		/* ---------- 编辑/取消/重置 ---------- */
		cancelEdit() {
			this.isDisabled = true;
			// 回滚到父组件传入的数据
			this.pageData();
		},
		/** 重置表单：工厂函数复用初始定义，避免重复抄写 */
		resetForm() {
			this.$refs.projectForm && this.$refs.projectForm.resetFields();
			this.$refs.contactForm && this.$refs.contactForm.resetFields();
			this.project = createInitialProject();
			this.contact = createInitialContact();
		},
	},
};
</script>

<style scoped lang="scss">
.content-title {
	color: #5E83CC;

	&::before {
		content: '';
		display: inline-block;
		vertical-align: middle;
		width: 4px;
		height: 16px;
		background-color: #5E83CC;
		margin-right: 8px;
	}
}

::v-deep {

	input[disabled],
	textarea[disabled] {
		background-color: #ffffff !important;
		border-color: #ffffff !important;
		color: #333 !important;
		cursor: auto !important;
	}
}

/* 确保进度条可见 */
:deep(.el-upload-list__item) {
	transition: all 0.3s;
}

:deep(.el-upload-list__item .el-progress) {
	width: 100%;
	margin-top: 5px;
}

:deep(.el-upload-list__item .el-progress-bar) {
	padding-right: 50px;
}

:deep(.el-upload-list__item .el-progress__text) {
	font-size: 12px;
}
</style>